import angular from 'angular';

const module = angular.module('whyline.constants.api_url', []);

let slug;
let url;
let apiUrl;
let v1serverUrl;
let v1clientUrl;
let analyticsUrl;
let kioskUrl;
let adminUrl;
let metricsUrl;
let socketUrl;

const { origin, protocol } = window.location;
const urlParts = origin.substring(origin.indexOf('://') + 3).split('.');
slug = urlParts[0];
const urlSplited = origin.split('.');
urlSplited[0] = `${protocol}//api-${slug}`;
url = urlSplited.join('.');
apiUrl = `${url}/api/v1/`;
urlSplited[0] = `${protocol}//api-virtualine`;
v1serverUrl = `${urlSplited.join('.')}/`;
urlSplited[0] = `${protocol}//virtualine`;
v1clientUrl = `${urlSplited.join('.')}/`;
kioskUrl = `https://kiosk.${urlSplited[1]}.whyline.com/`;
adminUrl = `https://admin.${urlSplited[1]}.whyline.com/`;
metricsUrl = 'https://macro.metrics.whyline.com/';

switch (urlParts[1]) {
  case 'uat':
    url = 'api-macroqms.uat.whyline.com';
    socketUrl = "wss://whylinews-qms-test.macro.com.ar"
    apiUrl = 'https://api-macroqms.uat.whyline.com/api/v1/';
    break;
  case 'preprod':
    apiUrl = 'https://whylinews-qms-prep.macro.com.ar/api/v1/';
    url = 'whylinews-qms-prep.macro.com.ar';
    break;
  case 'whyline':
    apiUrl = 'https://whylinews-qms.macro.com.ar/api/v1/';
    url = 'whylinews-qms.macro.com.ar';
    break;
}




socketUrl = `wss://whylinews-qms-test.macro.com.ar`;




analyticsUrl = 'http://analytics.dev.whyline.com';


const SOCKET_URL = localStorage.getItem('socketURL') || socketUrl;
const API_URL = localStorage.getItem('apiURL') || apiUrl;

module.constant('API_URL', API_URL);
module.constant('SOCKET_URL', SOCKET_URL);
module.constant('OLD_VERSION_SERVER_URL', v1serverUrl);
module.constant('OLD_VERSION_CLIENT_URL', v1clientUrl);
module.constant('ANALYTICS_CLIENT_URL', analyticsUrl);
module.constant('URL_NEW_KIOSK', kioskUrl);
module.constant('ADMIN_CLIENT_URL', adminUrl);
module.constant('METRICS_CLIENT_URL', metricsUrl);

module.exports = module;